import Pie2D from './pie2d';
import Doughnut2DDataset from '../_internal/datasets/doughnut2d';
// import CenterLabel from '../components/centerlabel';
import { pluck } from '../_internal/lib/lib';

class Doughnut2D extends Pie2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Doughnut2D';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Doughnut2D';
  }

  configureAttributes (dataObj) {
    super.configureAttributes(dataObj);
    let iapi = this,
      conf = iapi.config,
      chartAttrs = iapi.getFromEnv('chart-attrib');
      // dataset = iapi.getChildren('dataset')[0],
      // centerLabel;
    conf.doughnutradius = pluck(chartAttrs.doughnutradius, '50%');
    // if (!(centerLabel = iapi.getChildren('centerLabel'))) {
    //   centerLabel = iapi.attachChild(new CenterLabel(), 'centerLabel', false);
    //   iapi.addToEnv('centerLabel', centerLabel);
    //   centerLabel.setLinkedItem('dataset', dataset);
    // }
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Doughnut Chart';
    config.defaultDatasetType = 'Doughnut2D';
    config.singletonPlaceValue = false;
  }
  getDSdef () {
    return Doughnut2DDataset;
  }
}
export default Doughnut2D;
